import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

function App() {
  return (
    <div className="App-header">
    <div className="container">
      <div className="row">
        <h1>Termini e Condizioni d'uso dei prodotti Creativist</h1>
        <h2>Introduzione</h2>
        <p>Alcuni dei prodotti Creativist (ovvero 'Eatty' e 'RandomRide') sono da ritenersi <code>in sviluppo</code>, e pertanto non dispongono temporaneamente di alcuna funzionalità. Quando i servizi verranno ultimati verranno pubblicati degli annunci sui <a href="https://instagram.com/dabook_official">canali social di Creativist</a>.</p>
        <p className="mt-2">Il testo che segue non è ultimato e <span className="bold text-warning">potrebbe contenere errori </span>Leggi con attenzione questi Termini di Servizio ("ToS", "Termini", "Condizioni") attentamente prima di utilizzare i siti o i servizi ("Prodotti") di Team Creativist ("Noi", "Creativist", "Nostro"). Puoi contattarci alla nostra e-mail <a href="mailto:business.creativist@gmail.com">business.creativist@gmail.com</a></p>
        <h3 className="text-primary">Copyright</h3>
        <p>I contenuti pubblicati sui siti web Creativist (Incluso ma non limitato a Contenuti Scaricabili, Immagini, Testi, Grafiche e Loghi) sono proprietà di Team Creativist e i suoi contenut sono protetti dalle leggi internazionali sul copyright. L'intera raccolta dei contenuti presenti su questo sito Web è di proprietà esclusiva di Team Creativist, con la paternità del copyright per questa raccolta di Team Creativist.</p>

        <h3 className="text-primary">Leggi Applicabili</h3>
        <p>Visitando i nostri siti web accetti le leggi applicabili in Italia, indipendentemente da conflitti legislativi e le leggi detteranno l'andamento di eventuali dispute tra Noi e gli utenti.</p>

        <h3 className="text-primary">Controversie</h3>
        <p>Qualsiasi controversia riguardante i prodotti Creativist sarà gestita dalla legislazione italiana e acconsenti alla giurisdizione esclusiva italiana.</p>
        
        <h3 className="text-primary">Copia e ridistribuzione</h3>
        <p>Copiare e/o redistribuire i prodotti Creativist senza il nostro esplicito consenso è proibito.</p>

      </div>
    </div>
    </div>
  );
}

export default App;
